import React from 'react';

import { Box, Typography } from '@mui/material';

export const customOfferMerchantFeeFieldLabel = (
  <Box>
    <Typography>Enable merchant fees</Typography>
    <Typography variant="caption" color="text.secondary">
      Only applies in eligible regions (currently only applies to AU)
    </Typography>
  </Box>
);
